import { get, post, put } from "services/httpService";
import { AUTH_RTOKEN_KEY, AUTH_TOKEN_KEY } from "utils/constants";
import { getItemFromStorage, setItemInStorage } from "utils/storage";

const SERVICE_URLS = {
  getBrokers: () => `supported-brokers/`,
  getBrokerPortfolio: (brokerName) => `user/broker/${brokerName}/`,
  getTrackingId: () => `user/anonymous-tracking-id/`,
  getBrokerOAuthURL: () => `broker-accounts/oauth-url/`,
  getFrontIframeUrl: () => `broker/front/iframe`,
  getBannerDetails: () => `user/banner/`,
  getAccessToken: () => `user/refresh/`,
  userFlagsAPI: () => `user/flags/`,
  getSuggestedStrategies: () => `marketplace/suggested/`,
  questions: () => `questionnaire/`,
  retrieveAnswers: () => `questionnaire/answers`,
  combinedBackTest: () => `strategy/combined-backtest/`,
  suggestedAllocation: () => `strategies/ai-suggested-allocation/`,
  combinedStrategyHoldings: () => `strategy/combined-strategy-holdings/`,
  getBrokerAccounts: (strategyId) => `broker-accounts/${strategyId}/`,
  getBrokerAccount: (brokerAccountId) => `broker-accounts/${brokerAccountId}/`,
  createTradingConnection: (accountId) =>
    `trading-connection/create/?account_id=${accountId}`,
  postTradingConnection: () => `trading-connection/create/`,
  updateTradingAllocation: (brokerAccountId) =>
    `update-trading-allocation/${brokerAccountId}/`,
  getStrategyReturns: (strategyId) => `strategy/${strategyId}/returns/`,
  cashTransfers: () => `internal-account/cash-transfers/`,
  createCashTransfer: () => `internal-account/create-cash-transfer/`,
};

export const getSuggestedAllocation = (payload) =>
  post(SERVICE_URLS.suggestedAllocation(), payload);

export const getCombinedStrategyHoldings = (payload) =>
  post(SERVICE_URLS.combinedStrategyHoldings(), payload);

export const getTrackingId = () => get(SERVICE_URLS.getTrackingId());
export const getBrokers = () => get(SERVICE_URLS.getBrokers());
export const getBrokerPortfolio = (brokerName) =>
  get(SERVICE_URLS.getBrokerPortfolio(brokerName));
export const getSuggestedStrategies = () =>
  get(SERVICE_URLS.getSuggestedStrategies());
export const getBrokerOAuthURL = (brokerKey) => {
  const params = { broker: brokerKey };
  return get(SERVICE_URLS.getBrokerOAuthURL(), params);
};
export const getFrontIframeUrl = () => get(SERVICE_URLS.getFrontIframeUrl());
export const getBannerDetails = () => get(SERVICE_URLS.getBannerDetails());
export const getUserFlags = () => get(SERVICE_URLS.userFlagsAPI());

export const getAccessToken = async () => {
  const refresh = getItemFromStorage(AUTH_RTOKEN_KEY);
  if (refresh) {
    const response = await post(SERVICE_URLS.getAccessToken(), { refresh });
    setItemInStorage(AUTH_TOKEN_KEY, response.access);
  }
};

export const putUserFlags = (payload) =>
  put(SERVICE_URLS.userFlagsAPI(), payload);

export const getQuestions = (payload) => get(SERVICE_URLS.questions(), payload);

export const retrieveAnswers = () => get(SERVICE_URLS.retrieveAnswers());

export const saveQuestionAnswers = (payload) =>
  post(SERVICE_URLS.questions(), payload);

export const combinedBackTest = (payload) =>
  post(SERVICE_URLS.combinedBackTest(), payload);

export const getBrokerAccounts = (strategyId) =>
  get(SERVICE_URLS.getBrokerAccounts(strategyId));

export const createTradingConnection = (accountId) =>
  get(SERVICE_URLS.createTradingConnection(accountId));

export const postTradingConnection = (payload) =>
  post(SERVICE_URLS.postTradingConnection(), payload);

export const updateTradingAllocation = (brokerAccountId, payload) =>
  put(SERVICE_URLS.updateTradingAllocation(brokerAccountId), payload);

export const getStrategyReturns = (strategyId) =>
  get(SERVICE_URLS.getStrategyReturns(strategyId));

export const CASH_TRANSFERS_URL = SERVICE_URLS.cashTransfers();
export const CREATE_CASH_TRANSFER_URL = SERVICE_URLS.createCashTransfer();
